var FAKE_KEYCLOAK_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsi0JDQtNC80LjQvdC40YHRgtGA0LDRgtC-0YAiXX0sInByZWZlcnJlZF91c2VybmFtZSI6ItCY0LLQsNC90L7QsiDQmNCy0LDQvSIsImV4cCI6OTk5OTk5OTk5OX0.joLSTbiQjFKkzRTrFqwp5VF2NqWVD16IYvojKmhYpeM";
export var MOCK_USER = {
    id_token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkZXYtdXNlci0wMDEifQ.fake_id",
    session_state: "fake-session-state-123",
    access_token: FAKE_KEYCLOAK_TOKEN,
    refresh_token: "fake-refresh-token",
    token_type: "Bearer",
    scope: "openid profile email offline_access",
    profile: {
        preferred_username: "Иванов Иван",
        realm_access: { roles: ["Администратор"] },
    },
    expires_at: Math.floor(Date.now() / 1000) + 3600,
};
export var MOCK_ACCESS_LIST = {
    group: "Администратор",
    name: "Иванов Иван",
    preferred_username: "admin.user@example.com",
    permissions: [
        "CanAll",
        "CanViewMain",
        "CanViewStatistic",
        "CanViewConfiguration",
    ],
    roles: "Администратор",
};
